<template>
    <vProductLicencePeriodListComponent :postList="postList" v-if="flag"></vProductLicencePeriodListComponent>
</template>
<script>
import vProductLicencePeriodListComponent from '../../listComponent/basicdata/product/productLicencePeriodComponent.vue';
export default {
    name: 'productLicencePeriodList',
    components: {
        vProductLicencePeriodListComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                updateBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                product_licence_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>